import React from "react";
import { Link } from "react-router-dom"

const UserDropdown = () => {

  const userRole = JSON.parse(localStorage.getItem("role"))

  return (
    <>
      <Link
        className="text-blueGray-500 block"
        to={userRole === "admin" ? "/admin/dashboard" : "/user/profile"}
      >
        <div className="items-center flex">
          <span className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
            <img
              alt="..."
              className="w-full rounded-full align-middle border-none shadow-lg"
              src={require("../../assets/img/avatar.jpg").default}
            />
          </span>
        </div>
      </Link>
    </>
  );
};

export default UserDropdown;
